import { atom, selector } from "recoil";
import React from "react";
import moment from "moment";
import { createDataRequest, updateDataRequest, createNoteRequest, deletePtmFileRequest, getArrivalFlightListRequest, getDepartureFlightListRequest } from "../../../api/controller/TransferBagController";
import { pageState } from "../../../state/GlobalState";
import { permissionState } from "../../../api/state/AuthState";

export const transferBagListState = atom({
    key: 'transferBagListState',
    default: [],
})
export const transferBagFromFlightState = atom({
	key: 'transferBagFromFlightState',
	default:{
		data:[],
		ovf:false,
	}
})
export const transferBagToFlightState = atom({
	key: 'transferBagToFlightState',
	default:{
		data:[],
		ovf:false,
	}
})


export const modalConfigDefault = { size: "lg", wizard: false }

export const filtersDefault = [
    {
        label: 'Date',
        name: 'Date',
        size: 6,
        offset: 6,
        required: true,
        type: 'date',
        value: moment().format('YYYY-MM-DD'),
    },
]

export const formModes = {
    create: [ { name: 'Default Create', action: createDataRequest } ], 
    update: [ { name: 'Default Update', action: updateDataRequest }, { name: 'Create Note', action: createNoteRequest, closeOnSubmit: true } ],
    view: [ { name: 'Default View' } ],
}

export const transferBagDataStructureState = selector({
    key: 'transferBagDataStructureState',
    get: ({ get }) => (
        [

            { 
                label: 'From Flight Date',
                type: 'datepicker',
                order: { form: 1 }, 
				table: { dateFormat: 'MMM Do, YYYY', postDateFormat:'YYYY-MM-DD' },
                create: [{ enabled: true, size: { xs: 12, md: 6 } , dateFormat: 'YYYY-MM-DD', default: moment().format('YYYY-MM-DD'), options: { altInput: true, altFormat: 'F j, Y', dateFormat: 'Y-m-d' } }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
                child: {
                    name: "FromFlight",
                    subFields: { label: "name", value: "name" }, 
                    fn: getArrivalFlightListRequest
                }
            },
			{ 
                label: 'From Flight',
                type: 'select',
                rootValue: true,
                order: { table: 1, form: 2 }, 
				table: {
					editable: true,
					minWidth: 140,
					valueGetter: (data) => {
						const flight = data.from_flight != null && data.from_flight !== '' ? String(data.from_flight) : '';
						const d = data.from_flight_date ? moment(data.from_flight_date).format('DD-MMM-YY') : '';
						return [flight, d].filter(Boolean).join(' ') || '—';
					},
					customRender: (_value, params) => {
						const flight = params.data.from_flight;
						const flightLine = flight != null && flight !== '' ? String(flight) : '—';
						const dateRaw = params.data.from_flight_date;
						const dateLine = dateRaw ? moment(dateRaw).format('DD-MMM-YY') : '—';
						return (
							<div
								style={{
									display: 'flex',
									flexDirection: 'row',
									alignItems: 'center',
									gap: 8,
									marginTop: 7,
									minHeight: 0,
								}}
							>
								<i
									className="mdi mdi-airplane-landing"
									style={{ fontSize: '1.05rem', color: '#0369a1', flexShrink: 0, lineHeight: 1 }}
									aria-hidden
								/>
								<div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 2, lineHeight: 1.3, minWidth: 0 }}>
								<span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={flightLine}>
									{flightLine}
								</span>
								<span
									style={{
										overflow: 'hidden',
										textOverflow: 'ellipsis',
										whiteSpace: 'nowrap',
										fontSize: '0.8125rem',
										color: '#64748b',
									}}
									title={dateLine}
							>
									{dateLine}
								</span>
								</div>
							</div>
						);
					},
				},
                create: [{ enabled: true, size: { xs: 12, md: 6 }, validations: 'disabled_if:FromFlightDate,null' }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
                list: get(transferBagFromFlightState),
            },
			{ 
                label: 'To Flight Date',
                type: 'datepicker',
                order: { form: 3 }, 
				table: { dateFormat: 'MMM Do, YYYY', postDateFormat:'YYYY-MM-DD' },
                create: [{ enabled: true, size: { xs: 12, md: 6 } , dateFormat: 'YYYY-MM-DD', default: moment().format('YYYY-MM-DD'), options: { altInput: true, altFormat: 'F j, Y', dateFormat: 'Y-m-d' } }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
                child: {
                    name: "ToFlight",
                    subFields: { label: "name", value: "name" }, 
                    fn: getDepartureFlightListRequest
                }
            },
			{ 
                label: 'To Flight',
                type: 'select',
                rootValue: true,
                order: { table: 2, form: 4 }, 
				table: {
					editable: true,
					minWidth: 140,
					valueGetter: (data) => {
						const flight = data.to_flight != null && data.to_flight !== '' ? String(data.to_flight) : '';
						const d = data.to_flight_date ? moment(data.to_flight_date).format('DD-MMM-YY') : '';
						return [flight, d].filter(Boolean).join(' ') || '—';
					},
					customRender: (_value, params) => {
						const flight = params.data.to_flight;
						const flightLine = flight != null && flight !== '' ? String(flight) : '—';
						const dateRaw = params.data.to_flight_date;
						const dateLine = dateRaw ? moment(dateRaw).format('DD-MMM-YY') : '—';
						return (
							<div
								style={{
									display: 'flex',
									flexDirection: 'row',
									alignItems: 'center',
									gap: 8,
									marginTop: 7,
									minHeight: 0,
								}}
							>
								<i
									className="mdi mdi-airplane-takeoff"
									style={{ fontSize: '1.05rem', color: '#0369a1', flexShrink: 0, lineHeight: 1 }}
									aria-hidden
								/>
								<div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 2, lineHeight: 1.3, minWidth: 0 }}>
								<span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={flightLine}>
									{flightLine}
								</span>
								<span
									style={{
										overflow: 'hidden',
										textOverflow: 'ellipsis',
										whiteSpace: 'nowrap',
										fontSize: '0.8125rem',
										color: '#64748b',
									}}
									title={dateLine}
								>
									{dateLine}
								</span>
								</div>
							</div>
						);
					},
				},
                create: [{ enabled: true, size: { xs: 12, md: 6 }, validations: 'disabled_if:ToFlightDate,null' }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
                list: get(transferBagToFlightState),
            },
			{ 
                label: 'Total Bags',
				tableHeader: 'Bags',
                type: 'number',
                order: { table: 3, form: 5 }, 
				table: {
					editable: false,
					minWidth: 150,
					valueGetter: (data) => {
						const t = Number(data.total_bags ?? 0);
						const r = Number(data.bags_received ?? 0);
						const c = Number(data.bags_connected ?? 0);
						return `${r}/${t} received ${c}/${t} connected`;
					},
					customRender: (_value, params) => {
						const t = Number(params.data.total_bags ?? 0);
						const r = Number(params.data.bags_received ?? 0);
						const c = Number(params.data.bags_connected ?? 0);
						return (
							<div
								style={{
									display: 'flex',
									flexDirection: 'row',
									alignItems: 'center',
									gap: 8,
									marginTop: 7,
									minHeight: 0,
								}}
							>
								<i
									className="mdi mdi-bag-suitcase"
									style={{ fontSize: '1.05rem', color: '#0369a1', flexShrink: 0, lineHeight: 1 }}
									aria-hidden
								/>
								<div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 2, lineHeight: 1.3, minWidth: 0 }}>
								<span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={`${r} of ${t} bags received`}>
									{r}/{t} bags received
								</span>
								<span
									style={{
										overflow: 'hidden',
										textOverflow: 'ellipsis',
										whiteSpace: 'nowrap',
										fontSize: '0.8125rem',
										color: '#64748b',
									}}
									title={`${c} of ${t} bags connected`}
								>
									{c}/{t} bags connected
								</span>
								</div>
							</div>
						);
					},
				},
                create: [{ enabled: true, size: { xs: 12, md: 4 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Bags Received',
                type: 'number',
                order: { form: 6 }, 
                create: [{ enabled: true, size: { xs: 12, md: 4 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Bags Connected',
                type: 'number',
                order: { form: 7 }, 
                create: [{ enabled: true, size: { xs: 12, md: 4 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Remarks',
                name: 'Remarks',
                field: 'remarks',
                type: 'text',
                order: { form: 8 }, 
                create: [{ enabled: true, size: { xs: 12, md: 12 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
			{
				name: 'PTM',
				label: 'PTM',
				field: 'p_t_m',
				type: 'dropzone',
				order: { form: 9 },
				create: [{ enabled: true, size: { xs: 12 } }],
				update: ['same_as:create.0', { enabled: false }],
				view: ['same_as:create.0'],
				deleteFn: deletePtmFileRequest,
			},

            
			{ 
                label: 'Notes',
                type: 'repeater',
                order: { form: 10 },
                create: [{ enabled: false }], update: [{ enabled: false }, { enabled: false }], view: [{ enabled: true, size: { xs: 12, md: 12, lg: 12 }, deleteBtnSize: { xs: 2, md: 1 }, repeatLabel: true, divider: true }],
                children: [
                    { 
                		label: 'Note',
                		type: 'text',
                		order: { form: 1 }, 
                		create: [{ enabled: false }], update: [{ enabled: false }, { enabled: false }], view: [{ enabled: true, size: { xs: 12, md: 6, lg: 8 }  }], 
            		},
                    { 
                		label: 'User',
                		type: 'select',
                		order: { form: 2 }, 
                		create: [{ enabled: false }], update: [{ enabled: false }, { enabled: false }], view: [{ enabled: true, size: { xs: 12, md: 3, lg: 2 }  }], 
            		},
                    { 
                		label: 'Time',
                		type: 'datepicker',
						field: 'created_at',
                		order: { form: 3 }, 
                		create: [{ enabled: false }], update: [{ enabled: false }, { enabled: false }], view: [{ enabled: true, size: { xs: 12, md: 3, lg: 2 }, dateFormat: 'MMM Do, HH:mm' }], 
            		},
				]
			},

			{
				label: 'Note',
				type: 'textarea',
				order: { form: 10.1 }, 
				create: [{ enabled: false }], 
				update: [
					'same_as:create.0',
					{ enabled: true, size: { xs: 12 } },
				], 
				view: ['same_as:create.0'],
            },

        ].filter((v)=>{
            const page = get(pageState)
            const permissions = get(permissionState)
            if(! v.permission){
                return true
            }
            let absolute = false;
            if(v.permission.substr(0,1) === ":"){
                absolute = true;
                v.permission = v.permission.substr(1)
            }
            v.permission = absolute ? v.permission : v.permission + "-" + page
            return permissions?.includes(v.permission)
        })
    )
})
